import { Chip } from '@mui/material';
import { roundAmount } from '../../../../../utils/roundAmount';

export const FORECAST_REGISTER_TBL_HEAD = [
  {
    field: 'course_enrollment_id',
    headerName: 'Enrollment ID',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'admn_no',
    headerName: 'Admission No',
    width: 140,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    width: 180,
    sortable: true,
  },

  {
    field: 'email',
    headerName: 'Email',
    width: 200,
    valueGetter: (params) => params.row.email || '-',
  },
  {
    field: 'phone',
    headerName: 'Phone',
    width: 150,
  },
  {
    field: 'course_name',
    headerName: 'Course',
    width: 250,
    sortable: true,
  },

  // ✅ Status with valueGetter
  {
    field: 'course_enrollment_status',
    headerName: 'Status',
    width: 170,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => {
      const value = params.row.course_enrollment_status;
      if (value === 1) return 'Active';
      if (value === 2) return 'Temporarily Inactive';
      return 'Inactive';
    },
    renderCell: (params) => {
      const value = params.row.course_enrollment_status;
      const label = value === 1 ? 'Active' : value === 2 ? 'Temporarily Inactive' : 'Inactive';
      const color = value === 1 ? 'success' : value === 2 ? 'warning' : 'default';
      return <Chip label={label} size="small" color={color} variant={value === 1 ? 'outlined' : 'filled'} sx={{ fontSize: 11 }} />;
    },
    sortable: true,
  },

  {
    field: 'cro_name',
    headerName: 'CRO',
    width: 170,
    sortable: true,
  },
  {
    field: 'oga_name',
    headerName: 'OGA',
    width: 170,
    sortable: true,
  },

  {
    field: 'course_enrollment_timestamp',
    headerName: 'Enrollment Date',
    width: 170,
    sortable: true,
  },

  // 💰 Pricing
  {
    field: 'cart_item_mrp',
    headerName: 'MRP',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'cart_item_discount',
    headerName: 'Discount',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'saleAmt',
    headerName: 'Sale Amount',
    width: 150,
    align: 'right',
    headerAlign: 'right',
    sortable: true,
  },
  {
    field: 'income_amount',
    headerName: 'Collected Fee (INR)',
    width: 200,
    align: 'right',
    headerAlign: 'right',
    valueGetter: (params) => roundAmount(params.row.income_amount),
    sortable: true,
  },
  {
    field: 'income_amount_aed',
    headerName: 'Collected Fee (AED)',
    width: 200,
    align: 'right',
    headerAlign: 'right',
    valueGetter: (params) => roundAmount(params.row.income_amount_aed),
    sortable: true,
  },

  // ✅ Currency using valueGetter
  {
    field: 'currency_type',
    headerName: 'Currency',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => {
      const value = params.row.currency_type;
      if (value === 1) return 'INR';
      if (value === 2) return 'AED';
      if (value === 3) return 'AED to INR';
      return 'INR';
    },
    sortable: true,
  },

  // 💵 Income

  // 📊 Academic
  {
    field: 'subjects_count',
    headerName: 'Subjects',
    width: 110,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'total_sessions_all_subjects',
    headerName: 'Total Sessions',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'total_classes_taken',
    headerName: 'Completed Sessions',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'completed_sessions_monthly',
    headerName: 'Completed Monthly Sessions',
    width: 250,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'prev_month_completed_sessions',
    headerName: 'Prev Month Sessions',
    description: 'Total classes completed in the previous month',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'last_session_date',
    headerName: 'Last Session Date',
    description: 'Date of the most recent class attended by the student',
    width: 180,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => params.row.last_session_date || '-',
    sortable: true,
  },
  {
    field: 'total_weekly_classes',
    headerName: 'Weekly Classes',
    width: 180,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },
  {
    field: 'is_calendar_created',
    headerName: 'Calendar Created',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => (params.row.is_calendar_created ? 'Yes' : 'No'),
    sortable: true,
  },
  {
    field: 'current_month_expected_sessions',
    headerName: 'Scheduled Sessions',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },

  {
    field: 'peak_classes_taken',
    headerName: 'Peak Classes',
    width: 130,
    align: 'center',
    headerAlign: 'center',
    sortable: true,
  },

  // 🔮 Forecast Section

  {
    field: 'is_forecast_created',
    headerName: 'Forecast Created',
    width: 200,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) => (params.row.is_forecast_created ? 'Yes' : 'No'),
    sortable: true,
  },
  {
    field: 'forecast_type',
    headerName: 'Forecast Type',
    width: 160,
    align: 'center',
    headerAlign: 'center',
    valueGetter: (params) =>
      params.row.forecast_type == 1 ? 'Options' : params.row.forecast_type == 2 ? 'Percentage' : 'Manual',
    sortable: true,
  },
  {
    field: 'selected_option_percentage',
    headerName: 'Option / Percentage',
    width: 220,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    valueGetter: (params) => {
      const { course_available_forcast_type, term_options_inr, term_options_aed, percentage_options, currency_type } = params.row;
      
      // The backend returns course_available_forcast_type, but some mappings might use forecast_type. Check both.
      const fType = params.row.forecast_type || course_available_forcast_type;

      // Normalize JSON columns that may arrive as stringified arrays
      const toArray = (val) => {
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
          try {
            const parsed = JSON.parse(val);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            return [];
          }
        }
        return [];
      };

      // Options (term) type -> show the chosen term fee schedule in the row currency.
      // Prefer the backend's currency-resolved term_options_actual (handles currency 3/AEDTOINR
      // by converting term_options_aed to INR — term_options_inr is an independently-priced
      // track on the same course_options row, not a currency conversion, so it's wrong for
      // AEDTOINR carts). Fall back to the old currency==2 branch if the field isn't present.
      if (fType == 1) {
        const resolved = params.row.term_options_actual ?? (currency_type == 2 ? term_options_aed : term_options_inr);
        let options = toArray(resolved);
        // If the terms are saved as objects { amount: 100 }, map them to just the numbers
        options = options.map(opt => (typeof opt === 'object' && opt !== null && opt.amount !== undefined) ? opt.amount : opt);
        return options.length ? options.join(' | ') : '—';
      }

      // Percentage type -> show the chosen percentage milestones
      if (fType == 2) {
        const pcts = toArray(percentage_options);
        return pcts.length ? pcts.map((p) => `${p}%`).join(' | ') : '—';
      }

      // Manual / no selection
      return 'Manual';
    },
  },
];

